import { usePDF } from '@react-pdf/renderer';
import React, { useEffect, useMemo } from 'react';
import OrderDocument from './OrderDocument';
import { TemplateRenderer, useTemplateOrFallback } from 'PDF/TemplateEngine';
import { resolveDocDesign } from 'PDF/TemplateEngine/resolveDocDesign';
import useSignatureUrls from 'hooks/useSignatureUrls';

function Dowload(props) {
  const { data, items, config } = props;
  const { template, loading } = useTemplateOrFallback('orden');

  const { urls: signatureUrls, ready: signaturesReady } = useSignatureUrls({
    specialist_signature: data?.specialist_signature,
    recepcionist_signature: data?.recepcionist_signature,
  });

  const design = loading ? null : resolveDocDesign(data, template);

  // No devolver null acá: usePDF con document=null queda trabado en loading.
  const document = useMemo(() => {
    const dataWithSignatures = {
      ...data,
      specialist_signature: signaturesReady ? signatureUrls.specialist_signature : null,
      recepcionist_signature: signaturesReady ? signatureUrls.recepcionist_signature : null,
    };
    if (design === 'lowcode') {
      const mergedData = { ...dataWithSignatures, items };
      return <TemplateRenderer template={template} data={mergedData} config={config || {}} />;
    }
    return <OrderDocument config={config} data={dataWithSignatures} items={items} />;
  }, [design, template, data, items, config, signaturesReady, signatureUrls]);

  // usePDF@4 no regenera el PDF cuando cambia el document prop; hay que
  // llamar updateInstance manualmente (ver comentario en Voucher/Dowload).
  const [instance, updateInstance] = usePDF({ document });
  useEffect(() => {
    if (document) updateInstance(document);
  }, [document, updateInstance]);

  if (loading || !signaturesReady || instance.loading) return <div>Cargando...</div>;
  if (instance.error) return <div>Algo salió mal: {instance.error}</div>;
  return (
    <a href={instance.url} download={`order N°${data.id_budget}.pdf`}>
      Descargar Orden
    </a>
  );
}

export default Dowload;
